import { render, staticRenderFns } from "./HeaderAppTips.vue?vue&type=template&id=4b401ccb&scoped=true"
import script from "./HeaderAppTips.vue?vue&type=script&lang=js"
export * from "./HeaderAppTips.vue?vue&type=script&lang=js"
import style0 from "./HeaderAppTips.vue?vue&type=style&index=0&id=4b401ccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b401ccb",
  null
  
)

export default component.exports